// extracted by mini-css-extract-plugin
export default {"message":"RefreshConfigPopup_message__XW9fR","centeredFooter":"RefreshConfigPopup_centeredFooter__Tulek"};